import LBox from "@components/LBox";
import LText from "@components/LText";
import { useAlbumsSuspense } from "@hooks/trpc/useAlbums";
import type { Album } from "@libs/wire";
import type { ReactNode } from "react";

interface Props {
  id: string;
  children: (album: Album | undefined, isFetching: boolean) => ReactNode;
}

// The catalogue serves an album only while it is available to the listener
// (see `catalog.albums.getById`). A link to one it does not serve says so
// here instead of leaving the album address.
const AlbumGate = ({ id, children }: Props) => {
  const {
    query: { data, isFetching },
  } = useAlbumsSuspense([id]);
  const album = data?.at(0);

  if (!album && !isFetching) {
    return (
      <LBox
        alignItems="center"
        flex={1}
        gap="s3"
        justifyContent="center"
        px="s4"
      >
        <LText variant="h1">Album unavailable</LText>
        <LText color="textGrey" textAlign="center" variant="bodyL">
          This album is not available on Lissen right now.
        </LText>
      </LBox>
    );
  }

  return <>{children(album, isFetching)}</>;
};

export default AlbumGate;
